import { postJson, request } from './request';

export interface TemplateStat {
  usageCount: number;
  likeCount: number;
}

export interface TemplateStatsResponse {
  stats: Record<string, TemplateStat>;
  likedTemplateIds: string[];
}

export const fetchTemplateStats = (): Promise<TemplateStatsResponse> =>
  request<TemplateStatsResponse>('/api/templates/stats');

export const toggleTemplateLike = (
  templateId: string,
): Promise<{ liked: boolean; likeCount: number }> =>
  postJson<{ liked: boolean; likeCount: number }>(`/api/templates/${templateId}/like`, {});
